<template>
    <console-content max-width="1280px">
        <v-row class="mt-8" justify="center" align="center">
            <v-col cols="auto" class="pt-0 pb-0 headline text-start">회원목록</v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pt-0 pb-0">
                <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mx-auto">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="filter.name" hide-details type="text" label="사용자이름"
                                placeholder=" " />
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-text-field v-model="filter.phone" hide-details type="text" label="연락처" placeholder=" " />
                        </v-col>
                    </v-row>
                    <v-row class="mt-6">
                        <v-col cols="12" sm="6" class="py-0">
                            <v-select v-model="filter._level" :items="[{ name: '전체', _id: null }].concat(levels)"
                                item-text="name" item-value="_id" hide-details label="회원등급" placeholder=" "></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <v-select v-model="filter.warning" :items="warningsItems" item-text="text"
                                item-value="value" hide-details label="주의회원" placeholder=" "></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-4">
            <v-spacer></v-spacer>
            <v-col cols="auto">
                <v-btn color="white" class="green--text px-2" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table :headers="usersHeaders" :items="users" disable-sort disable-pagination hide-default-footer
            class="elevation-1">
            <template v-slot:item.createdAt="{ item }">
                <span v-if="item.createdAt">{{ item.createdAt.toDateTime() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.phone="{ item }">
                <span v-if="item.phone">{{ item.phone.phoneNumberFormat() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.email="{ item }">
                <span v-if="item.email">{{ item.email }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.level="{ item }">
                <span v-if="item.level">{{ item.level.name }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.cash="{ item }">
                <span v-if="item.cash">{{ item.cash.format() }}원</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.warning="{ item }">
                <v-row justify="center" align="center">
                    <v-col cols="auto" class="pa-0">
                        <v-switch v-model="item.warning" color="red lighten-1" hide-details dens class="mt-0"
                            @change="updateUser({ _id: item._id, warning: item.warning })"></v-switch>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:item.orderPrice="{ item }">
                <span v-if="item.orderPrice">{{ item.orderPrice.format() }}</span>
                <span v-else>-</span>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small @click="edit(item)"> mdi-pencil </v-icon>
            </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12 mx-4" @input="search()">
        </v-pagination>

        <v-dialog>
            <template #activator>
                <v-btn bottom color="accent" dark fab fixed right @click="create">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
        </v-dialog>

    </console-content>
</template>

<script>
import ConsoleContent from "@/components/console/console-content.vue";

import XLSX from "xlsx";
import api from "@/api";

import {
    mdiMicrosoftExcel
} from "@mdi/js";

export default {
    components: {
        ConsoleContent
    },
    props: {
        viewType: String,
    },
    data() {
        return {
            mdiMicrosoftExcel, // 엑셀아이콘

            showSearch: true,

            filter: {
                name: this.$route.query.name,
                phone: this.$route.query.phone,
                _level: JSON.parse(this.$route.query._level || "null"),
                warning: JSON.parse(this.$route.query.warning || "null"),
                withdraw: JSON.parse(this.$route.query.withdraw || "null"),
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            users: [],
            usersHeaders: [{
                    text: "사용자 이름",
                    align: "center",
                    width: 200,
                    value: "name",
                },
                {
                    text: "연락처",
                    align: "center",
                    width: 128,
                    value: "phone",
                },
                {
                    text: "이메일",
                    align: "center",
                    width: 128,
                    value: "email",
                },
                {
                    text: "등급",
                    align: "center",
                    width: 140,
                    value: "level",
                },
                {
                    text: "주의회원",
                    width: 100,
                    align: "center",
                    value: "warning",
                },
                {
                    text: "캐시잔액",
                    width: 100,
                    align: "center",
                    value: "cash",
                },
                {
                    text: "가입일자",
                    align: "center",
                    width: 160,
                    value: "createdAt",
                },
                {
                    text: "Actions",
                    value: "actions",
                    width: 100,
                    align: "center",
                },
            ],

            levels: [],

            warningsItems: [{
                    text: "전체",
                    value: null
                },
                {
                    text: "주의회원",
                    value: true
                },
                {
                    text: "미주의회원",
                    value: false
                },
            ],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                var {
                    levels
                } = await api.console.levels.getLevels();
                this.levels = levels;

                this.search();
            } catch (error) {
                console.error(error);
            }
        },
        async search() {
            try {
                this.$router.push({
                    query: Object.assignDefined({}, this.$route.query, this.filter, {
                        page: this.page,
                    }),
                });

                var {
                    summary,
                    users
                } = await api.console.users.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: this.filter,
                });

                this.users = users;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message.toString());
            }
        },

        create(){
            this.$router.replace(`/console/users/create`);
        },

        edit(user) {
            this.$router.push(`/console/users/${user._id}`);
        },

        async updateUser(user) {
            try {
                await api.console.users.putUser(user);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async excel() {
            try {
                var {
                    users
                } = await api.console.users.getUsers({
                    filter: this.filter,
                });

                var rows = [];
                users.forEach((user) => {
                    rows.push({
                        "사용자 이름": user.name,
                        연락처: user.phone,
                        이메일: user.email,
                        회원등급: user.level.name ? user.level.name : "-",
                        주의회원여부: user.warning ? "주의" : "-",
                        캐시잔액: user.cash,
                        가입일자: user.createDate.toDateTime(),
                    });
                });

                var workbook = new XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, "회원목록.xlsx");
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    computed: {
        test(){
            return this.$store.state.test;
        }
    }
};
</script>
